import { Add, Delete } from "@mui/icons-material";
import { Button, Grid, TextField } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import { useState } from "react";
import { useForm } from "react-hook-form";
import {
  ButtonContainer,
  StyledChoiceFileText,
  StyledContainerBox,
  StyledStack,
  StyledUploadBox,
} from "./EditClassFile.style";

import useHttp from "hooks/use-http";
import {
  deleteTeacherClassFileByIdRequest,
  editTeacherClassFileRequest,
  getTeacherClassFileByIdRequest,
} from "api/requests";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import LoadingCM from "components/shared/Loading";
import { IoMdCloudUpload } from "react-icons/io";
import { yupResolver } from "@hookform/resolvers/yup";
import { teacherUploadFileSchema, validateFile } from "validations";
import Toast from "helper/toast";
import ProgressBarCM from "components/shared/ProgressBar";
import useModal from "hooks/use-modal";
import DeleteModal from "components/shared/Modal/Delete";
import BackButton from "components/shared/BackButton";

export default function EditTeacherClassFiles() {
  const { file_id } = useParams();
  const navigate = useNavigate();

  const [newFile, setNewFile] = useState(null);

  // Modal hook

  const { setOpen, setConfirm, open } = useModal();

  // http hook
  const { loading, request, uploadProgress, isUploading, setUploadProgress } =
    useHttp();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(teacherUploadFileSchema) });

  const deleteFileHandler = async () => {
    const res = await request({
      url: deleteTeacherClassFileByIdRequest,
      values: file_id,
    });

    if (res.data) {
      setConfirm(true);
      Toast({
        type: "success",
        title: `حذف `,
        autoClose: 3000,
      });
      navigate(-1);
    }
  };

  // add new file
  const onSubmit = async (data) => {
    const fileTypeValidate = newFile
      ? validateFile(data.file[0], "فایل", 15_000_000, [
          "png",
          "jpg",
          "jpeg",
          "pdf",
          "zip",
          "rar",
        ])
      : true;

    if (!fileTypeValidate) {
      return null;
    }

    const res = await request({
      url: () =>
        editTeacherClassFileRequest(
          {
            id: file_id,
            title: data.title ?? null,
            file: newFile ? data.file[0] : null,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({
        type: "success",
        title: `ویرایش `,
        autoClose: 3000,
      });

      reset({
        file: "",
        title: "",
        educational_year: "",
      });

      navigate(-1);
      setNewFile(null);
    }
  };

  // get class files
  const getClassFile = async () => {
    const { data: res } = await request({
      url: getTeacherClassFileByIdRequest,
      values: file_id,
    });

    reset({
      title: res?.title ?? "",
      file: "",
    });
  };

  useEffect(() => {
    getClassFile();
  }, []);

  return (
    <DrawerCM title={"ویرایش فایل"} $styledHeader>
      <Grid item xs={12} my={3}>
        <BackButton />
      </Grid>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <StyledStack>
          <Grid container>
            <Grid item sm={6} xs={12} p={1}>
              <TextField
                label="عنوان"
                variant="outlined"
                fullWidth
                id="title"
                type={"text"}
                {...register("title")}
                error={Boolean(errors.title)}
                helperText={errors?.title?.message}
              />
            </Grid>
            <Grid item sm={6} xs={12} p={1}>
              <StyledContainerBox>
                <StyledUploadBox>
                  <StyledChoiceFileText>
                    {newFile ? newFile : "آپلود فایل جدید"}
                  </StyledChoiceFileText>
                  <IoMdCloudUpload />
                </StyledUploadBox>
                <TextField
                  variant="outlined"
                  type="file"
                  fullWidth
                  {...register("file")}
                  onChange={(e) => setNewFile(e.target.files[0].name)}
                />
              </StyledContainerBox>
            </Grid>
            <Grid item sm={12} xs={12}>
              <ButtonContainer>
                <Button
                  sx={{ m: 1 }}
                  color="error"
                  variant="contained"
                  size="large"
                  endIcon={<Delete />}
                  onClick={() => setOpen(true)}
                >
                  حذف
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  size="large"
                  endIcon={<Add />}
                  onClick={handleSubmit(onSubmit)}
                >
                  ویرایش
                </Button>
              </ButtonContainer>
            </Grid>
            <DeleteModal
              show={open}
              onClose={() => setOpen(false)}
              onDelete={deleteFileHandler}
            />
          </Grid>
        </StyledStack>
      )}
    </DrawerCM>
  );
}
